export interface CompanyEntity {
  id: string;
  name: string;
  enabled: boolean;
  userLimit: number;
  numberOfTeamsLimit: number;
  enableHolidayBooking: boolean;
  deskBookingEnabled: boolean;
  lineManagementEnabled: boolean;
  sevenDayWhereaboutsWeekEnabled: boolean;
  whereaboutsApprovalsEnabled: boolean;
  domainNameSignupsEnabled: boolean;
  holidayApprovalEnabled: boolean;
  calendarSyncEnabled: boolean;
  trial: boolean;
  logoUrl?: string;
  holidayApprovalNotificationsEnabled: boolean;
  notifyManagerOnLeaveCancellation?: boolean;
  tenantBasedAuthEnabled?: boolean;
  weeklyNotesEnabled?: boolean;
  disableEditingPreviousWhereabouts: boolean;
  officeAttendanceConfirmationEnabled: boolean;
  overduePayment: boolean;
  meetingRoomLimit: number;
  iconPack: IconPack;
  visitorBookingEnabled: boolean;
  privateGroups?: boolean;
  schengenTracking?: boolean;
  restrictTeamManagement?: boolean;
  departmentFromScim: boolean;
  disableNewScimUserEmail: boolean;
  disableNewScimUserAccessToLogin: boolean;
  showBirthdays?: boolean;
  accountType?: AccountType;

  globalReminder?: GlobalReminder;
  automaticOfficeCheckinEnabled?: boolean;
  mcpIntegrationEnabled?: boolean;
  lockersEnabled?: boolean;
  signageEnabled?: boolean;
  // FULL_NAMES | INITIALS | RESERVED_ONLY; undefined = FULL_NAMES
  signageNameDisplay?: string;
  // undefined = true
  signageShowSafetyRoles?: boolean;
}

export enum IconPack {
  STANDARD = 'STANDARD',
  BASIC = 'BASIC',
}

export enum GlobalReminder {
  ALL_USERS = "ALL_USERS",
  USERS_CHOICE = "USERS_CHOICE",
  NO_USERS = "NO_USERS",
}

export enum AccountType {
  FREE_TRIAL = "FREE_TRIAL",
  STANDARD = "STANDARD",
  PROFESSIONAL = "PROFESSIONAL",
  PREMIUM = "PREMIUM",
  ENTERPRISE = "ENTERPRISE",
}
